import { createDeleteEndpoint } from '@sonar-software/sonar-http';

export type DeleteDataDictionaryViewRequest = {
	id: number;
};

export const deleteDataDictionaryView = createDeleteEndpoint<DeleteDataDictionaryViewRequest>(
	'/api/v3/data-dictionary/views',
	{
		requestTransform: ({ id }) => ({
			customViewIds: [ id ]
		})
	}
);
